// NotificationPanel.js
// Public user notification panel for job portal

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useGlobalData } from '../context/GlobalDataContext';
import './NotificationPanelContainer.css';

const NotificationPanel = () => {
  const { notifications = [], profile = {} } = useGlobalData();
  const navigate = useNavigate();
  // Role check from JWT
  const [userRole] = React.useState(() => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.role || '';
      }
    } catch (e) {}
    return '';
  });


  React.useEffect(() => {
    if (userRole !== 'user') {
      navigate('/publicuser/login', { replace: true });
    }
  }, [userRole, navigate]);
  // Optionally, you can add a fetch here if profile is empty and setProfile is available, but context should already handle it.

  const missingProfile = !profile.age || !profile.education || !profile.location || !profile.gender;

  if (userRole !== 'user') return null;

  // Show loading spinner only if profile is empty (first load)
  const profileIsEmpty = !profile || Object.values(profile).every(v => !v);
  let showLoading = profileIsEmpty;

  return (
    <div className="notification-panel-container">
      <div className="notification-panel-title">Notifications</div>
      {showLoading ? (
        <div style={{textAlign:'center', color:'#888', margin:'2rem 0'}}>Loading...</div>
      ) : missingProfile ? (
        <div style={{textAlign:'center', color:'red', fontWeight:'bold', margin:'2rem 0'}}>
          Please update Profile then show notification
        </div>
      ) : (
        <div className="notification-list">
          {notifications && notifications.length > 0 ? (
            [...notifications].reverse().map((note, idx) => (
              <div
                className={`notification-card${note.unread ? ' notification-unread-card' : ''}`}
                key={idx}
              >
                <div className="notification-title">{note.title || 'Notification'}</div>
                <div className="notification-text">
                  {note.type === 'eligibility-match' && note.jobTitle ? (
                    <>
                      🎉 Your profile matches the eligibility for
                      {" "}
                      <a
                        href={
                          '/mform/' +
                          (note.jobSlug
                            ? note.jobSlug
                            : (note.jobTitle || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, ''))
                        }
                        style={{ color: '#4eaaff', textDecoration: 'underline', cursor: 'pointer' }}
                      >
                        {`"${note.jobTitle}"`}
                      </a>
                      .
                    </>
                  ) : (
                    note.message || note.text || note.body || ''
                  )}
                </div>
                <div className="notification-time">{note.time || note.date || ''}</div>
                {note.unread && <span className="notification-unread" title="Unread" />}
              </div>
            ))
          ) : (
            <div style={{textAlign:'center', color:'var(--notification-time-light)'}}>No notifications</div>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationPanel;
